module.exports = __webpack_public_path__ + "static/media/expand-table.eaf1cce6.png";